import { AxiosError } from 'axios';

import { DugoutConfig } from '@/types/config';
import { StaffUserSession } from '@/types/staffSession';
import { UserPermissions } from '@/types/user';
import ajax from '@/utils/ajax';
import { errorMessage } from '@/utils/mapAxiosErrorMessages';

export interface CurrentUserResponse {
  user: StaffUserSession;
  permissions: UserPermissions;
  config: DugoutConfig;
}

export const userRepository = {
  async getPermissions({
    host,
    userId
  }: {
    host: string;
    userId: string;
  }): Promise<UserPermissions | void> {
    try {
      const path = `/api/dugout/users/${userId}/permissions/`;
      const { data } = await ajax.get({
        url: `${host}${path}`
      });

      return data;
    } catch (error) {
      await Promise.reject(`Failed to get permissions. ${errorMessage(error as AxiosError)}`);
    }
  },

  async getCurrentUser({ host }: { host: string }): Promise<CurrentUserResponse | void> {
    try {
      const path = '/api/dugout/users/current_user/';
      const { data } = await ajax.get({
        url: `${host}${path}`
      });

      return data;
    } catch (error) {
      await Promise.reject(`Failed to get current user data. ${errorMessage(error as AxiosError)}`);
    }
  }
};

export default userRepository;
